<lib-action-button
    [kind]="ActionButtonKind.FILTER"
    fontImage="far fa-copy fa-bg"
    (click)="onClick()">
</lib-action-button>
